/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { APITokensPage } from '@/pages/APITokens/APITokensPage';

export function APITokenRoute() {
  return <APITokensPage />;
}
